import { css, type RuleSet } from 'styled-components';
import { isDesktopListSelector, isDesktopMapSelector } from '@/app/common/css/selectors.ts';

export const whenDesktopLayoutIsNarrow = (styles: RuleSet<object>) => css`
  ${isDesktopListSelector} &,
    ${isDesktopMapSelector} & {
    @media (max-width: 1023px) {
      ${styles};
    }
  }
`;

export const showOnlyOnDesktopInSearchPage = whenDesktopLayoutIsNarrow(css`
  display: none;
`);

export const showOnlyOnDesktopMapInSearchPage = css`
  ${isDesktopMapSelector} & {
    @media (max-width: 1023px) {
      display: none;
    }
  }
`;
